package com.daytimegaming.ourdailyfinances.data.billing

import com.daytimegaming.ourdailyfinances.domain.billing.PurchaseState
import com.daytimegaming.ourdailyfinances.domain.billing.SubscriptionManager
import com.daytimegaming.ourdailyfinances.domain.billing.SubscriptionProduct
import com.daytimegaming.ourdailyfinances.domain.repository.UserRepository
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlin.random.Random

class WebSubscriptionManager(
    private val userRepository: UserRepository
) : SubscriptionManager {

    private val _purchaseState = MutableStateFlow<PurchaseState>(PurchaseState.Idle)
    override val purchaseState: StateFlow<PurchaseState> = _purchaseState.asStateFlow()

    override fun setAndroidActivity(activity: Any?) {}

    override fun openSubscriptionManagement(productId: String?) {}

    override suspend fun loadProducts(): List<SubscriptionProduct> {
        return listOf(
            SubscriptionProduct("subscription_standard_monthly", "standard", "Standard Tier", "$5.00/mo", "Simulated Standard Access"),
            SubscriptionProduct("subscription_premium_monthly", "premium", "Premium Tier", "$10.00/mo", "Simulated Premium Access")
        )
    }

    override suspend fun buyProduct(productId: String, oldPurchaseToken: String?) {
        _purchaseState.value = PurchaseState.Loading
        delay(1500)
        val tier = if (productId.contains("premium")) "premium" else "standard"
        userRepository.saveLocalSubscription(tier = tier, active = true)
        val randomId = Random.nextInt(10000)
        _purchaseState.value = PurchaseState.Success(tier, "web-tx-$randomId")
    }
}
